import axios from 'axios';
import { openModal } from 'Store/actions';
import errorMessage from 'Store/actions/errorMessage';
import EnvironmentManager from 'Utils/environmentManager';

import {
  FORGOT_PASSWORD_OPTIONS_REQUEST,
  FORGOT_PASSWORD_OPTIONS_SUCCESS,
  FORGOT_PASSWORD_OPTIONS_FAILURE,
  
  FORGOT_PASSWORD_SEND_OTP_REQUEST,
  FORGOT_PASSWORD_SEND_OTP_SUCCESS,
  FORGOT_PASSWORD_SEND_OTP_FAILURE,
  
  FORGOT_PASSWORD_SEND_EMAIL_REQUEST,
  FORGOT_PASSWORD_SEND_EMAIL_SUCCESS,
  FORGOT_PASSWORD_SEND_EMAIL_FAILURE,
  
  FORGOT_PASSWORD_CHANGE_WITH_EMAIL_REQUEST,
  FORGOT_PASSWORD_CHANGE_WITH_EMAIL_SUCCESS,
  FORGOT_PASSWORD_CHANGE_WITH_EMAIL_FAILURE,
  
  FORGOT_PASSWORD_CHANGE_WITH_PHONE_NUMBER_REQUEST,
  FORGOT_PASSWORD_CHANGE_WITH_PHONE_NUMBER_SUCCESS,
  FORGOT_PASSWORD_CHANGE_WITH_PHONE_NUMBER_FAILURE,
  
  FORGOT_PASSWORD_CHECK_EMAIL_CODE_REQUEST,
  FORGOT_PASSWORD_CHECK_EMAIL_CODE_SUCCESS,
  FORGOT_PASSWORD_CHECK_EMAIL_CODE_FAILURE,
  
  SAVE_FORGOT_PASSWORD_UNKNOWN_USER_DATA,
  RESET_FORGOT_PASSWORD_UNKNOWN_USER_DATA,

  PREDEACTIVATED_STATUS_FORGOT_PASSWORD_REQUEST,
  PREDEACTIVATED_STATUS_FORGOT_PASSWORD_SUCCESS,
  PREDEACTIVATED_STATUS_FORGOT_PASSWORD_FAILURE,

  FORGOT_PASSWORD_OTP_VERIFY_REQUEST,
  FORGOT_PASSWORD_OTP_VERIFY_SUCCESS,
  FORGOT_PASSWORD_OTP_VERIFY_FAILURE
} from 'Store/constants';

export const getForgotPasswordOptions = formData => async dispatch => {
  try {
    
    dispatch({
      type: FORGOT_PASSWORD_OPTIONS_REQUEST
    });
    
    const res = await axios.post('/users/forgot/password/check', formData);
    
    dispatch({
      type: FORGOT_PASSWORD_OPTIONS_SUCCESS,
      payload: res.data
    });
  
    dispatch(openModal('chooseChangePasswordFlow'));
  
  } catch (e) {
    const data = e?.response?.data;
    const cmsMessage = EnvironmentManager.getMessageText({ key: `${data?.domain}${data?.code}` });
    const errorText = cmsMessage || data?.message || 'Beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.';

    const newResponse = {
      ...e,
      response: {
        ...e.response,
        data: {
          ...data,
          message: errorText
        }
      }
    };


    dispatch({
      type: FORGOT_PASSWORD_OPTIONS_FAILURE,
      payload: newResponse || errorMessage
    });
    if (data?.code === 40324) {
      dispatch(openModal('predeactivatedStatusForgotPassword', { formData }));
    } else if (data?.code === 40326) {
      dispatch(openModal('forgotPasswordYknError'));
    } else if (data?.code === 4073) {
      dispatch(openModal('forgotPasswordNoContactInfo'));
    } else {
      dispatch(openModal('forgotPasswordOptionsError'));
    }
  }
};

export const forgotPasswordSendOtp = formData => async dispatch => {
  try {
    
    dispatch({
      type: FORGOT_PASSWORD_SEND_OTP_REQUEST
    });
    
    const res = await axios.post('/users/forgot/password/v2/send-otp', formData);
    
    dispatch({
      type: FORGOT_PASSWORD_SEND_OTP_SUCCESS,
      payload: res.data
    });

    dispatch(openModal('otp'));

  } catch (e) {
    const data = e.response?.data;

    dispatch({
      type: FORGOT_PASSWORD_SEND_OTP_FAILURE,
      payload: data || errorMessage
    });

    if (data?.code === 4088) {
      dispatch(openModal('duplicateRequestErrorModal', { code: data.code, domain: data.domain }));
    } else {
      dispatch(openModal('changePasswordError'));
    }
  }
};

export const forgotPasswordSendEmail = formData => async dispatch => {
  try {
    
    dispatch({
      type: FORGOT_PASSWORD_SEND_EMAIL_REQUEST
    });
    
    const res = await axios.post('/users/forgot/password/send-email', formData);
    
    dispatch({
      type: FORGOT_PASSWORD_SEND_EMAIL_SUCCESS,
      payload: res.data
    });
  
    dispatch(openModal('newPasswordMailSendSuccess'));
  
  } catch (e) {
    const data = e.response?.data;

    dispatch({
      type: FORGOT_PASSWORD_SEND_EMAIL_FAILURE,
      payload: data || errorMessage
    });

    if (data?.code === 4088) {
      dispatch(openModal('duplicateRequestErrorModal', { code: data.code, domain: data.domain }));
    } else {
      dispatch(openModal('changePasswordError', data));
    }
  }
};

export const forgotPasswordChangeWithEmail = formData => async dispatch => {
  try {
    
    dispatch({
      type: FORGOT_PASSWORD_CHANGE_WITH_EMAIL_REQUEST
    });
    
    const res = await axios.post('/users/forgot/password/change/via/email', formData);
    
    dispatch({
      type: FORGOT_PASSWORD_CHANGE_WITH_EMAIL_SUCCESS,
      payload: res.data
    });
  
    dispatch(openModal('changePasswordSuccess'));
  } catch (e) {
    dispatch({
      type: FORGOT_PASSWORD_CHANGE_WITH_EMAIL_FAILURE,
      payload: (e.response && e.response.data) || errorMessage
    });
    dispatch(openModal('changePasswordError'));
  }
};

export const forgotPasswordChangeWithPhoneNumber = formData => dispatch => {
  return new Promise(async (resolve, reject) => {
    try {
      dispatch({
        type: FORGOT_PASSWORD_CHANGE_WITH_PHONE_NUMBER_REQUEST
      });
      
      const res = await axios.post('/users/forgot/password/v2/change/via/phone-number', formData);
      
      dispatch({
        type: FORGOT_PASSWORD_CHANGE_WITH_PHONE_NUMBER_SUCCESS,
        payload: res.data
      });
      
      dispatch(openModal('changePasswordSuccess'));
      resolve();
    } catch (e) {
      dispatch({
        type: FORGOT_PASSWORD_CHANGE_WITH_PHONE_NUMBER_FAILURE,
        payload: (e.response && e.response.data) || errorMessage
      });
      reject(e);
    }
  });
  
};


export const saveUnknownUserData = data => async dispatch => {
  dispatch({
    type: SAVE_FORGOT_PASSWORD_UNKNOWN_USER_DATA,
    payload: data
  });
};

export const resetUnknownUserData = () => async dispatch => {
  dispatch({
    type: RESET_FORGOT_PASSWORD_UNKNOWN_USER_DATA,
  });
};

export const checkEmailCode = code => async dispatch => {
  try {
    
    dispatch({
      type: FORGOT_PASSWORD_CHECK_EMAIL_CODE_REQUEST
    });
    
    await axios.get('/users/forgot/password/check/email-code?code=' + code);
    
    dispatch({
      type: FORGOT_PASSWORD_CHECK_EMAIL_CODE_SUCCESS
    });
    
  } catch (e) {
    dispatch({
      type: FORGOT_PASSWORD_CHECK_EMAIL_CODE_FAILURE,
      payload: (e.response && e.response.data) || errorMessage
    });
    dispatch(openModal('changePasswordEmailLinkError'));
  }
};

export const predeactivatedStatusForgotPassword = (birthDate, citizenshipNumber) => async dispatch => {
  try {

    dispatch({
      type: PREDEACTIVATED_STATUS_FORGOT_PASSWORD_REQUEST
    });

    const res = await axios({
      url: '/users/status/cancel/request/via/forgot-password',
      method: 'post',
      data: {
        birthDate,
        username: citizenshipNumber
      }
    });

    dispatch({
      type: PREDEACTIVATED_STATUS_FORGOT_PASSWORD_SUCCESS,
      payload: res.data
    });

  } catch (err) {
    dispatch({
      type: PREDEACTIVATED_STATUS_FORGOT_PASSWORD_FAILURE,
      payload: (err.response && err.response.data) || { message: errorMessage }
    });
  }
};

export const forgotPasswordVerifyOtp = formData => async dispatch => {
  return new Promise(async (resolve, reject) => {
    try {
    
      dispatch({
        type: FORGOT_PASSWORD_OTP_VERIFY_REQUEST
      });
      
      const res = await axios.post('/users/forgot/password/verify-otp', formData);
      
      dispatch({
        type: FORGOT_PASSWORD_OTP_VERIFY_SUCCESS,
        payload: res.data
      });
      resolve();
      
    } catch (e) {
      dispatch({
        type: FORGOT_PASSWORD_OTP_VERIFY_FAILURE,
        payload: (e.response && e.response.data) || errorMessage
      });
      reject(e);
    }
  });
};
